<template>
    <el-input
      v-model="value"
      @change="change"
      :disabled="disabled"
      :type="data.inputType"
      :class="{ bgColorInput: bgColor }"
      :autosize="autosize"
    ></el-input>
</template>

<script>
export default {
  //props: ["data", "modelDat", "disableStatus", "autosize"],
  props: {
    data: {
      type: Object,
    },
    modelDat: {
      type: [String, Boolean, Object, Number, Array],
    },
    disableStatus: {
      type: Boolean,
    },
    autosize: {
      type: Object,
    },
  },
  data() {
    return {
      value: this.modelDat,
      itemDisabled: false,
      bgColor: false,
      disabled: false,
    };
  },

  mounted() {
    // console.log("TCL: modelDat", this.modelDat);
    // console.log("TCL: data", this.data.inputType);
    // console.log("TCL: mounted -> this.data.disabled", this.data);
    if (this.data.disabled) {
      this.itemDisabled = true;
    }
    this.disabled = this.disableStatus || this.itemDisabled;
  },

  methods: {
    change() {
      console.log("changed",this.data.field, this.value);
      this.$emit("inputChange", {
        key: this.data.field,
        value: this.value,
      });
    },
  },

  watch: {
    data: {
      handler(newValue) {
        this.disabled = newValue.disabled || this.disableStatus;
      },
      deep: true,
    },

    modelDat(newValue) {
      //this.value = newValue;
      //
      if (typeof newValue === "string") {
        if (newValue !== "") {
          this.value = newValue;
        } else {
          this.value = "";
        }
      } else if (typeof newValue === "number") {
        if (newValue !== "") {
          this.value = newValue;
        } else {
          this.value = 0;
        }
      } else {
        this.value = newValue;
      }
      // if(JSON.stringify(newValue) === "{}") {
      //   this.value = ''

      // }else {
      //   this.value = newValue
      // }
    },

    disableStatus(newValue) {
      this.disabled = newValue || this.itemDisabled;
    },
    value(newValue) {
      if (newValue) {
        this.bgColor = true;
      }
      this.$emit("inputChange", {
        key: this.data.field,
        value: newValue,
      });
    },
  },
};
</script>
